export default "import.meta.ROLLUP_FILE_URL_65bea61d"